import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { List, ListItem, withStyles } from "material-ui";
//import { ItemGrid, Banner } from "components";
import { ItemGrid, Banner } from "components";
import { Grid } from "material-ui";

import footerStyle from "assets/jss/material-dashboard-react/footerStyle";

import DappsStore from "../../stores/DappsStore";


import logo from "assets/icon/hexagon-dark+text.svg";

// https://www.stateofthedapps.com/about
// <a href="https://trustwalletapp.com/logo-assets" target="_blank" rel="noopener">Media Assets</a>
// <a href="" target="_blank" rel="noopener" style={ style.a }>Contact us</a>

function CountersBlock({...props}) {
    const {classes, counters} = props;
    if (Object.getOwnPropertyNames(counters).length === 0) return false;
    return <ItemGrid xs={12} sm={6} md={12} lg={12}>
      <Grid container >
        <ItemGrid xs={4} sm={4} md={4} lg={4} className={ classes.counter } style={{
            fontSize: "16px",
            textAlign: "center"
        }}>
          <b className={ classes.b }>{counters.dapps}</b><br/> total dapps
        </ItemGrid>
        <ItemGrid xs={4} sm={4} md={4} lg={4} className={ classes.counter } style={{
            fontSize: "16px",
            textAlign: "center"
        }}>
          <b className={ classes.b }>{counters.contracts}</b><br/> smart contracts
        </ItemGrid>
        <ItemGrid xs={4} sm={4} md={4} lg={4} className={ classes.counter } style={{
            fontSize: "16px",
            textAlign: "center"
        }}>
          <b className={ classes.b }>{counters.dau}</b><br/> daily users
        </ItemGrid>
      </Grid>
      </ItemGrid>
}

function RecomendationItems({...props}) {
    const {classes, data} = props;
    let recommendationsItems = data.map(function(v, k) {
        return <ListItem key={k} className={ classes.listLinks }>
            <a href={v.link} target="_blank" rel="noopener noreferrer">{v.name}</a>
          </ListItem>
    });
    return recommendationsItems;
}

const recommendationsLinks = [
    {
        name: 'MetaMask',
        link: 'https://metamask.io/?from=dappstore'
    },
    {
        name: 'SafeWallet',
        link: 'https://www.cmcmbc.com/en-us/safe-wallet/?from=dappstore'
    },
    {
        name: 'Dapp Browser',
        link: 'https://www.cmcmbc.com/en-us/blockchainlab/?from=dappstore'
    },
    {
        name: 'Toshi Browser',
        link: 'https://www.toshi.org/?from=dappstore'
    },
    {
        name: 'Trust Wallet',
        link: 'https://trustwalletapp.com/?from=dappstore'
    },
];


class Footer extends React.Component {

    state = {
        counters: {},
    };

    componentWillMount() {
        let self = this;
        DappsStore.getHeadDataPromise.then(function(e) {
            self.setState({
                counters: DappsStore.data.total
            });
        });
    }

    render() {
        const {classes} = this.props;
        // console.log(this.state.counters);
        return (
            <div>

<Grid container className={ classes.footerContainer }>
  <Banner/>

  <ItemGrid xs={6} sm={6} md={3} lg={3}>
    <h4 className={ classes.titleLinks }>Useful Links</h4>
    <List className={classes.list}>
            <ListItem className={ classes.listLinks }>
            <NavLink
              to="/about"
              >About Us</NavLink>
            </ListItem>
            <ListItem className={ classes.listLinks }>
              <a onClick={ this.props.addDapp } className="pointer" >Submit a ÐApp</a>
            </ListItem>
            <ListItem className={ classes.listLinks }>
              <a href="https://t.me/DAppStore" target="_blank" rel="noopener noreferrer">Telegram</a>
            </ListItem>
            <ListItem className={ classes.listLinks }>
              <a href="https://fb.me/dappstore.site" target="_blank" rel="noopener noreferrer">Facebook</a>
            </ListItem>
    </List>
  </ItemGrid>

  <ItemGrid xs={6} sm={6} md={3} lg={3}>
    <h4 className={ classes.titleLinks }>Recommendations</h4>
    <List className={classes.list}>
      <RecomendationItems data={recommendationsLinks} classes={classes} />
    </List>
  </ItemGrid>


  <ItemGrid xs={12} sm={12} md={6} lg={6}>
    <Grid container >
    <ItemGrid xs={12} sm={6} md={12} lg={12}>
      <img src={logo} alt="DAppStore" className={ classes.logo }/>
    </ItemGrid>
    
    <CountersBlock classes={classes} counters={ this.state.counters } />
    
    </Grid>
  </ItemGrid>

</Grid >

    <footer className={classes.footer}>
      <div className={classes.container}> 
        <p className={classes.right}>
          <span>
            © {1900 + new Date().getYear()}{" "}
            <a href="https://dappstore.link/" className={classes.a}>
              ÐAppStore
            </a> - Projects Built on Blockchain
          </span>
        </p>
      </div>
    </footer>
{ /*
        <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a href="/" className={classes.block}>
                Home
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a role="button" onClick={(e) => {
            window.open('https://t.me/DAppStore');
        }} className={classes.block + ' pointer'}>
                Telegram
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a role="button" onClick={(e) => {
            window.open('https://fb.me/dappstore.site');
        }} className={classes.block + ' pointer'}>
                Facebook
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a role="button" onClick={(e) => {
            window.open('https://t.me/RomanGladun');
        }} className={classes.block + ' pointer'}>
                Submit ÐApp
              </a>
            </ListItem>
          </List>
        </div>

        <p className={classes.right}>
          <span>
            © {1900 + new Date().getYear()}{" "}
            <a href="http://dappstore.link/" className={classes.a}>
              ÐAppStore
            </a> - Projects Built on Blockchain
          </span>
        </p>
      </div>
    </footer>
  */ }
    </div>
        );
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx